import React, { useState } from 'react';
import { FaInstagram, FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import LegalModal from './LegalModal';

export default function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const termsContent = (
  <div className="space-y-4">
    <p className="text-sm text-gray-300">
      Welcome to Scholarly Edge. By booking our services or using our website, you agree to the following terms and conditions.
    </p>

    {[
      {
        heading: "1. Services",
        text: "We offer professional services including thesis, data analysis,reseach, and more.",
      },
      {
        heading: "2. Booking & Cancellation",
        text: "Bookings require advance payment which is 10% of total amount. Cancellations must be made 2 days in advance for a refund.",
      },
      {
        heading: "3. Payments",
        text: "Payment must be completed in full before final delivery. We accept UPI, cash, or bank transfer.",
      },
      {
        heading: "4. Updates",
        text: "We may update terms at any time. Please check this page regularly.",
      },
    ].map(({ heading, text }, i) => (
      <div
        key={i}
        className="bg-gray-800/70 rounded-xl p-4 border border-gray-700/40 hover:shadow transition"
      >
        <h3 className="text-base font-semibold text-pink-400">{heading}</h3>
        <p className="text-sm text-gray-300 mt-1">{text}</p>
      </div>
    ))}
  </div>
);


const privacyContent = (
  <div className="space-y-4">
    <p className="text-sm text-gray-300">
      Scholerly Edge respects your privacy and is committed to protecting your personal information.
    </p>
    {[
      {
        heading: "1. Data Collection",
        text: "We collect name, contact info, and event details to provide our services.",
      },
      {
        heading: "2. Use of Data",
        text: "Your data is used only to manage bookings and send communication.",
      },
      {
        heading: "3. Third Parties",
        text: "We never sell or share your data with third parties.",
      },
      {
        heading: "4. Security",
        text: "We implement security measures to protect your data.",
      },
      {
        heading: "5. Updates",
        text: "We may update this policy occasionally. Please review it regularly.",
      },
    ].map(({ heading, text }, i) => (
      <div
        key={i}
        className="bg-gray-800/70 rounded-xl p-4 border border-gray-700/40 hover:shadow transition"
      >
        <h3 className="text-base font-semibold text-pink-400">{heading}</h3>
        <p className="text-sm text-gray-300 mt-1">{text}</p>
      </div>
    ))}
  </div>
);


  return (
    <footer className="bg-gray-900 text-white py-8 mt-16">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center px-4">
        
        {/* Left: Brand Info */}
        <div className="mb-6 md:mb-0 text-center md:text-left">
          <h2 className="text-xl font-bold">Scholarly Edge</h2>
          <p className="text-sm text-gray-400">Fueling Ambitions One Chapter At A Time.</p>
        </div>

        {/* Terms and Privacy Links */}
        <div className="mt-2 text-center text-xs text-gray-500">
          <div className="flex justify-center space-x-4">
            <a href="#" onClick={(e) => { e.preventDefault(); setShowTerms(true); }} className="hover:text-white">
              Terms & Conditions
            </a>
            <span>|</span>
            <a href="#" onClick={(e) => { e.preventDefault(); setShowPrivacy(true); }} className="hover:text-white">
              Privacy
            </a>
          </div>
        </div>

        {/* Right: Social + Location */}
        <div className="flex flex-col items-center md:items-end space-y-2">
          {/* Social Media Section */}
          <div className="flex flex-col items-center">
            <p className="text-xs font-semibold uppercase tracking-wider mb-1">Follow Us</p>
            <div className="flex space-x-5 text-lg">
              {/* <a
                href="https://www.instagram.com/vishal_palav_photography_1"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/your_page"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >
                <FaFacebookF />
              </a> */}
              <a
                href="https://wa.me/7420029121"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Serving Location */}
          <p className="text-sm text-gray-400"> Serving: All over India</p>
        </div>
      </div>

      {/* Bottom: Copyright */}
      <div className="text-center text-gray-500 text-xs mt-4">
        © {new Date().getFullYear()} scholarly edge. All rights reserved.
      </div>

      {/* Modals */}
      <LegalModal
        show={showTerms}
        onClose={() => setShowTerms(false)}
        title="Terms & Conditions"
      >
        {termsContent}
      </LegalModal>

      <LegalModal
        show={showPrivacy}
        onClose={() => setShowPrivacy(false)}
        title="Privacy Policy"
      >
        {privacyContent}
      </LegalModal>
    </footer>
  );
}
